import React from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import qs from 'qs'
import { get } from 'lodash'
import { Redirect } from 'react-router-dom'
import { parseJWT, setClientToken } from 'src/auth'
import { AUTH } from 'src/constants'
import { buildUrlParamObj } from 'src/helpers/utils'
import { redirect } from 'src/helpers/browser'
import { setReferrerSource } from 'src/actions/trackingSource'
import { fetchCustomMailer } from 'src/actions/customMailer'
import { flagClientForUnsubscribe } from 'src/actions/client'
import { PATH_HELPERS } from 'src/constants/navigation'

const propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    hash: PropTypes.string,
    search: PropTypes.string
  })
}

const AuthCallback = ({ location }) => {
  const dispatch = useDispatch()
  const { hash, search } = location

  if (!hash) {
    redirect(AUTH.SSO_REDIRECT_URI)
    return null
  }

  const {
    state: resourceId,
    type: resourceIndicator,
    unsubscribe: unsubParam,
    targetEl: elementRef,
    targetPath: routeForSource,
    'referrer-source': referrerSource,
    customMailerId
  } = qs.parse(search.replace(/^\?/, ''))

  const { access_token: token, unsubscribe: unsubFragment } = buildUrlParamObj(
    hash,
    '#'
  )
  // Supporting both until url structure resolved
  const unsubscribe = Boolean(unsubParam || unsubFragment)
  if (unsubscribe) {
    dispatch(flagClientForUnsubscribe(resourceIndicator))
  }

  if (!token || !resourceId) {
    redirect(AUTH.SSO_REDIRECT_URI)
    return null
  }

  setClientToken(token)

  dispatch(setReferrerSource(referrerSource))

  if (customMailerId) {
    dispatch(fetchCustomMailer(customMailerId))
  }

  if (resourceIndicator === 'homes') {
    const clientId =
      get(parseJWT(token), 'acr.values[0].context', '').replace(
        /client:/,
        ''
      ) || null

    let path
    if (clientId && clientId.length === 36) {
      path = PATH_HELPERS.home.buildPath(clientId, resourceId)
      if (unsubscribe) {
        path += `/preferences`
      }
    } else {
      path = `/reports/home/${resourceId}`
    }

    if (elementRef) {
      path += `#${elementRef}`
    }

    if (routeForSource) {
      path += routeForSource
    }

    return <Redirect to={path} />
  }

  let path
  if (customMailerId) {
    path = PATH_HELPERS.buy.buildPath(resourceId)
  } else {
    path = PATH_HELPERS.markets.buildPath(resourceId, '/explore')
  }

  if (unsubscribe) {
    path = PATH_HELPERS.buy.buildPath(resourceId, '/preferences')
  }
  return <Redirect to={path} />
}

AuthCallback.propTypes = propTypes

export default AuthCallback
